import { useQuery } from 'react-query'
import axios from 'axios'
import { API_URL } from '../../config'
import { rqDefaultOptions } from './defaultOptions'

const getAllMOLineage = async (inputObj) => {
  const { email } = inputObj.queryKey[1]
  axios.defaults.headers.common['Authorization'] = email
  const apiPath = `${API_URL}/api/moLineage/v1/getMOLineageData`
  const res = await axios.get(apiPath)
  return res.data
}

export function useAllMOLineage(queryKey, email) {
  const options = {
    ...rqDefaultOptions,
  }
  return useQuery([queryKey, { email }], getAllMOLineage, options)
}
